import React, { useContext, useRef, useState, useEffect } from 'react';
import { Table, Button, Row, Col, Form } from 'react-bootstrap';
import { useReactToPrint } from "react-to-print";
import ShowAttachments from '../../ViewAttachments/ShowAttachments';
import defaultAvatar from '../../../assets/defaultAvatar.jpg';
import axios from 'axios';
import Preloader from '../../../components/Preloader/Preloader';
import CBSEApplicationPrintView from './CBSEApplicationPrintView';
import { mockOpenJobs } from '../../../AppData';

const config = require('../../../config.json');

/*const mockOpenJobs = [
    { jobPostingID: 'JOB001', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'KG Teacher', subject: 'Early Education', qualification: 'Any Degree & NTT/Montessori or D.El.Ed.', noOfPositions: 9, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' },
    { jobPostingID: 'JOB002', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PRT', subject: 'Tamil', qualification: 'B.A. / B. Lit., B.Ed.', noOfPositions: 3, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' },
    { jobPostingID: 'JOB003', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PRT', subject: 'English', qualification: 'B.A. English, B.Ed.', noOfPositions: 2, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' },
    { jobPostingID: 'JOB004', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PRT', subject: 'Maths', qualification: 'B.Sc. Maths, B.Ed.', noOfPositions: 5, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' },
    { jobPostingID: 'JOB005', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PRT', subject: 'EVS', qualification: 'B.Sc. Physics/Chemistry/Botany/Zoology, B.Ed.', noOfPositions: 3, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' },
    { jobPostingID: 'JOB006', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PRT', subject: 'Computer Science', qualification: 'B.Sc. Computer Science / BCA, B.Ed.', noOfPositions: 2, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' },
    { jobPostingID: 'JOB007', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PRT', subject: 'Hindi', qualification: 'B.A (Hindi), B.Ed.', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' },
    { jobPostingID: 'JOB008', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'TGT', subject: 'English', qualification: 'B.A.(English), B.Ed.', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' },
    { jobPostingID: 'JOB009', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'TGT', subject: 'Tamil', qualification: 'B.A. / B. Lit., B.Ed.', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' },
    { jobPostingID: 'JOB010', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'TGT', subject: 'Maths', qualification: 'B.Sc. Maths, B.Ed.', noOfPositions: 3, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' },
    { jobPostingID: 'JOB011', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'TGT', subject: 'Physics', qualification: 'B.Sc. Physics, B.Ed.', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' },
    { jobPostingID: 'JOB012', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'TGT', subject: 'Biology', qualification: 'B.Sc. Botany/Zoology, B.Ed.', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' },
    { jobPostingID: 'JOB013', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'TGT', subject: 'Social Science', qualification: 'B.A. History/Geography/ Economics, B.Ed.', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' },
    { jobPostingID: 'JOB014', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PRT', subject: 'Fine Arts', qualification: 'B.F.A / B.Sc. VisCom', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' },
    { jobPostingID: 'JOB015', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PET', subject: 'Physical Education', qualification: 'B.P.Ed.', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' },
    { jobPostingID: 'JOB016', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'Counsellor', subject: 'Guidance & Counselling', qualification: 'B.A / B.Sc. Psychology', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', appliedSchoolID:'MDUEDN1018' }
  ];*/


function CBSEPrintView(props) {
  const { handleApplicationStatusChange,remarks, setRemarks, applicationFormType, openJobs } = props;
  const contentRef = useRef(null);
    const [applicantId, setApplicantId] = React.useState('');
  
    const [application, setApplication]= useState({applicantName: '', postApplied: '', appliedSchool: '', dob:'',
      jobPostingID:'',applicationID:'', applicationStatus:'', staffID:'', appliedSchoolID:'', appliedPost:'', applicantName:'', 
      dateOfBirth:'', gender:'', emailID:'', phoneNumber:'', religion:'', bloodGroup:'', caste:'', casteName:'',
       communityCertNo:'', ug_subject:'', ug_passingyear:'', ug_university:'', ug_mode:'', ug_percentage:'', ug_class:'', 
       pg_subject:'', pg_passingyear:'', pg_university:'', pg_mode:'', pg_percentage:'', pg_class:'', bed_subject:'',
        bed_passingyear:'', bed_university:'', bed_mode:'', bed_percentage:'', bed_class:'', o_subject:'', o_passingyear:'',
        o_university:'', o_mode:'', o_percentage:'', o_class:'', c_jobStatus:'', p_teachingDetails:'', p_teachingWhere:'', 
        fatherName:'', fatherEducation:'', fatherOccupation:'', fatherIncome:'', motherName:'', motherEducation:'', 
        motherOccupation:'', motherIncome:'', maritalStatus:'', siblinginJesuitSchool:'', parentinJesuitSchool:'', 
        co_activities:'', otherSkills:'', currentAddress:'', permanentAddress:'',cpincode: '',ppincode:'', terms:false
    });
    const [dataAvailable, setDataAvailable] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
  
  const [searchDetails, setSearchDetails] = useState({ emailID: '', dateOfBirth: ''});
  const [loaded, setLoaded] = useState(true);
  const [dispMsg, setDispMsg] = useState('');

  // Function to retrieve tapplicantID cookie value

  const reactToPrintFn = useReactToPrint({ contentRef });

    // Function to retrieve tapplicantID cookie value
    function getApplicantIdFromCookie() {
      if (typeof document !== 'undefined') {
        const match = document.cookie.match(/(?:^|; )tapplicantID=([^;]*)/);
        return match ? decodeURIComponent(match[1]) : '';
      }
      return '';
    }
  
    useEffect(() => {
      //const id = getApplicantIdFromCookie();
      //setApplicantId(id);
      if(mockOpenJobs.length>0){
        setSearchDetails({...searchDetails, jobID: mockOpenJobs[0].jobPostingID})
      }
    }, [mockOpenJobs]);
    
     const handleSearch = async (event) => {
      event.preventDefault();
      setDispMsg('');
        try{
          if(searchDetails.dateOfBirth===''||searchDetails.emailID===''||searchDetails.jobID===''){
            alert("Please fill all the fields to search your application");
            setDispMsg("Please fill all the fields to search your application");  
          }else{
            setLoaded(false);
            setDataAvailable(false);
           // const { idToken } = (await fetchAuthSession()).tokens ?? {};
            const clientID='MDUEDN';
            const searchValue = searchDetails.emailID;
            const searchValueDOB = searchDetails.dateOfBirth;
            const searchTopic = 'JobPrint';
            console.log("searchDetails : ", searchDetails);
            await axios.get(`${config.api.invokeURL}/staff/cbseapplications?fetchKey=${searchValue}&fetchOption=${searchTopic}&clientID=${clientID}&searchDOB=${searchValueDOB}&jobID=${searchDetails.jobID}`, {
            headers: {
             // Authorization: idToken,
              'x-api-key':config.api.key
            }
          }).then(async(response) => {
           console.log("response : ", response.data);
            if(response.data.length>0)
            {
                setSearchResults(response.data);
                setApplication(response.data[0]);
                setDataAvailable(true);
                setSearchDetails({ emailID: '', dateOfBirth: '' });
                setDispMsg("Application found. You can proceed to print the application.");
            }else{
              setDataAvailable(false);
              setApplication({... application, applicationID:'' });
              //setSearchResults([]);
              setDispMsg("No application found with the provided details.");
            }
          
            //enqueueSnackbar(response.data.length + " - Staff's records found!",{variant:'success'}); 
            setLoaded(true);
        }).catch((error)=>{
          //enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
        setLoaded(true);
      })
          }
        }catch(error){
          //enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
        setLoaded(true);
        }
      }
  
        const handleImageError=(e)=>{
    // console.log("Event : ", e);
    e.target.src = defaultAvatar;
  }



  return (
    <div style={{ width: '90vw', minHeight: '100vh', margin: 0, padding: 20, background: '#f8fafc' }}>
      {!loaded &&  <Preloader show={loaded ? false : true} /> }

         {applicantId && (
          <div className='alert alert-info'>Reference Application ID: {applicantId}</div>
        )}

        <div className="search-container-modern">
          <h2 className="search-title">🔍 Retrieve Your Application</h2>
          <p className="search-subtitle">Enter your details to find and print your application</p>

          <div className="search-form-wrapper">
            <Row className="g-3 search-row">
              <Form.Group as={Col} xs={12} sm={6} md={3} controlId="jobIDField" className="form-group-modern">
                <Form.Label className="form-label-modern">Job Position *</Form.Label>
                <Form.Select
                  name="jobID"
                  value={searchDetails.jobID}
                  onChange={event=>{setSearchDetails({...searchDetails, jobID: event.target.value})}}
                  className="form-select-modern"
                >
                  <option value="">Select Job Position</option>
                  {mockOpenJobs.map((item, index)=>
                    <option key={index} value={item.jobPostingID}>
                      {item.positionApplied} - {item.subject} - {item.jobPostingID}
                    </option>
                  )}                
                </Form.Select>
              </Form.Group>

              <Form.Group as={Col} xs={12} sm={6} md={3} controlId="emailIDField" className="form-group-modern">
                <Form.Label className="form-label-modern">Email Address *</Form.Label>
                <Form.Control
                  type="email"
                  name="emailID"
                  value={searchDetails.emailID}
                  onChange={event=>setSearchDetails({...searchDetails, emailID: event.target.value})}
                  placeholder="your.email@example.com"
                  className="form-control-modern"
                />
              </Form.Group>

              <Form.Group as={Col} xs={12} sm={6} md={3} controlId="dobField" className="form-group-modern">
                <Form.Label className="form-label-modern">Date of Birth *</Form.Label>
                <Form.Control
                  type="date"
                  name="dateOfBirth"
                  value={searchDetails.dateOfBirth}
                  onChange={event=>setSearchDetails({...searchDetails, dateOfBirth: event.target.value})}
                  className="form-control-modern"
                />
              </Form.Group>

              <Form.Group as={Col} xs={12} sm={6} md={3} controlId="searchButton" className="form-group-modern d-flex align-items-end">
                <Button onClick={event=>handleSearch(event)} className="btn-search-modern w-100">
                  🔎 Search Application
                </Button>
              </Form.Group>
            </Row>
          </div>
        </div>

        {dispMsg && <div className={`alert-modern ${dispMsg.includes('No application') ? 'alert-error' : 'alert-success'}`}>{dispMsg}</div>}
      
        <div className="support-card-modern">
          <div className="support-icon">📞</div>
          <div className="support-content">
            <h5>Need Help?</h5>
            <p>For queries or assistance, please contact our Help Desk support team</p>
            <p className="support-email"><strong>Email:</strong> <a href="mailto:support@idntica.com">support@idntica.com</a></p>
          </div>
        </div>

        {application.applicationID && searchResults.length>0 && <CBSEApplicationPrintView applicationData={application}/>}

      {/*application.applicationID && searchResults.length>0 && <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
        <Button onClick={reactToPrintFn}>Print</Button>
      </div>
      <div ref={contentRef}>
        <div  className="print-summary-view" style={{maxWidth:'1200px', margin:'auto', background:'#fff', padding:'2rem', borderRadius:'12px', boxShadow:'0 2px 12px 0 rgba(44,62,80,0.07)'}}>
      <h4 className="mb-4 text-center">Registration Summary - {application.applicationID}</h4>
      <div className="section-title mb-3 mt-2" style={{
        background: 'linear-gradient(90deg, #e0e7ef 0%, #f8fafc 60%, #c7d2fe 100%)',
        borderRadius: '12px',
        padding: '12px 0',
        boxShadow: '0 2px 12px 0 rgba(44,62,80,0.07)',
        textAlign: 'center',
        marginBottom: '2rem',
      }}>
        <h4 className="fw-bold" style={{color: '#1a2740', letterSpacing: 1, margin: 0}}>Personal Details</h4>
      </div>
      <Row className='d-flex '>
       
          <Col className='column' md={9}>
          <div className="mb-3"><strong>Post Applied:</strong> {application.appliedPost}</div>
          <div className="mb-3"><strong>School Name:</strong> {application.schoolName}</div>
          <div className="mb-3"><strong>Name of the Applicant:</strong> {application.applicantName}</div>
</Col>


        
        <Col className='column' md={3} style={{float:'right', textAlign:'right', paddingRight:'10%'}}>
        <img src={`https://s3.ap-south-1.amazonaws.com/images.mduschooled.in/staff/cbse/${application.appliedSchoolID}/${application.applicationID}/profile/${application.files.userPhoto}`} alt="Photo" onError={handleImageError} style={{width:"6rem", height:"6rem", borderRadius:"50%"}}  />
        </Col>
       
        
      </Row>
      <Row>
        <Col><div className="mb-3"><strong>Date of Birth:</strong> {application.dateOfBirth}</div></Col>
        <Col><div className="mb-3"><strong>Gender:</strong> {application.gender}</div></Col>
      </Row>
      <Row>
      <Col><div className="mb-3"><strong>Email Id:</strong> {application.emailID}</div></Col>
      <Col><div className="mb-3"><strong>Phone Number:</strong> {application.phoneNumber}</div></Col>
      </Row>
      <div className="section-title mb-3 mt-2" style={{
        background: 'linear-gradient(90deg, #e0e7ef 0%, #f8fafc 60%, #c7d2fe 100%)',
        borderRadius: '12px',
        padding: '12px 0',
        boxShadow: '0 2px 12px 0 rgba(44,62,80,0.07)',
        textAlign: 'center',
        marginBottom: '2rem',
      }}>
        <h4 className="fw-bold" style={{color: '#1a2740', letterSpacing: 1, margin: 0}}>Educational Details</h4>
      </div>
      <Table className='table table-bordered responsive'>
        <thead>
          <tr>
            <th>Qualification</th>
            <th>Main Subject</th>
            <th>Year of Passing</th>
            <th>Board / University</th>
            <th>Regular / Corres.</th>
            <th>Percentage</th>
            <th>Class</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>UG</td>
            <td>{application.ug_subject}</td>
            <td>{application.ug_passingyear}</td>
            <td>{application.ug_university}</td>
            <td>{application.ug_mode}</td>
            <td>{application.ug_percentage}</td>
            <td>{application.ug_class}</td>
          </tr>
          <tr>
            <td>PG</td>
            <td>{application.pg_subject}</td>
            <td>{application.pg_passingyear}</td>
            <td>{application.pg_university}</td>
            <td>{application.pg_mode}</td>
            <td>{application.pg_percentage}</td>
            <td>{application.pg_class}</td>
          </tr>
          <tr>
            <td>D.T.Ed</td>
            <td>{application.bed_subject}</td>
            <td>{application.bed_passingyear}</td>
            <td>{application.bed_university}</td>
            <td>{application.bed_mode}</td>
            <td>{application.bed_percentage}</td>
            <td>{application.bed_class}</td>
          </tr>
          <tr>
            <td>Any Other</td>
            <td>{application.o_subject}</td>
            <td>{application.o_passingyear}</td>
            <td>{application.o_university}</td>
            <td>{application.o_mode}</td>
            <td>{application.o_percentage}</td>
            <td>{application.o_class}</td>
          </tr>
        </tbody>
      </Table>
      <div className="section-title mb-3 mt-2" style={{
        background: 'linear-gradient(90deg, #e0e7ef 0%, #f8fafc 60%, #c7d2fe 100%)',
        borderRadius: '12px',
        padding: '12px 0',
        boxShadow: '0 2px 12px 0 rgba(44,62,80,0.07)',
        textAlign: 'center',
        marginBottom: '2rem',
      }}>
        <h4 className="fw-bold" style={{color: '#1a2740', letterSpacing: 1, margin: 0}}>Family Background</h4>
      </div>
      <Row>
      <Col><div className="mb-3"><strong>Father's Name:</strong> {application.fatherName}</div></Col>
      <Col><div className="mb-3"><strong>Father's Education:</strong> {application.fatherEducation}</div></Col>
      </Row>
      <Row>
      <Col><div className="mb-3"><strong>Father's Occupation:</strong> {application.fatherOccupation}</div></Col>
      <Col><div className="mb-3"><strong>Father's Ann. Income:</strong> {application.fatherIncome}</div></Col>
      </Row>
      <Row>
      <Col><div className="mb-3"><strong>Mother's Name:</strong> {application.motherName}</div></Col>
      <Col><div className="mb-3"><strong>Mother's Education:</strong> {application.motherEducation}</div></Col>
      </Row>
      <Row>
      <Col><div className="mb-3"><strong>Mother's Occupation:</strong> {application.motherOccupation}</div></Col>
      <Col><div className="mb-3"><strong>Mother's Ann. Income:</strong> {application.motherIncome}</div></Col>
      </Row>
      <Row>
        <Col><div className="mb-3"><strong>Marital Status:</strong> {application.maritalStatus}</div></Col>
        <Col><div className="mb-3"><strong>Sibling in Jesuit School:</strong> {application.siblinginJesuitSchool}</div></Col>
      </Row>
      <Row>
        <Col><div className="mb-3"><strong>Parent in Jesuit School:</strong> {application.parentinJesuitSchool}</div></Col>
        <Col><div className="mb-3"><strong>Cocurricular Activities:</strong> {application.co_activities}</div></Col>
      </Row>
      <div className="mb-3"><strong>Other Skills:</strong> {application.otherSkills}</div>
      <Row>
      <Col><div className="mb-3"><strong>Current Address:</strong> {application.currentAddress}</div></Col>
      <Col><div className="mb-3"><strong>Communication Pincode:</strong> {application.cpincode}</div></Col>
      </Row>
      <Row>
        <Col><div className="mb-3"><strong>Permanent Address:</strong> {application.permanentAddress}</div></Col>
        <Col><div className="mb-3"><strong>Permanent Pincode:</strong> {application.ppincode}</div></Col>
      </Row>
      <ShowAttachments application={application} handleApplicationStatusChange={handleApplicationStatusChange} 
      remarks={remarks} setRemarks={setRemarks} applicationFormType={applicationFormType} />
      <Row>
        <Col><div className="mb-3"><strong>Payment Transaction No:</strong> {application.paymentReceiptNo}</div></Col>
        <Col><div className="mb-3"><strong>Transaction Date:</strong> {application.transactionDate}</div></Col>
      </Row>
      <div className="mb-3"><strong>Agreed to Terms:</strong> {application.terms ? 'Yes' : 'No'}</div>
    </div>
    </div>
    </>
  */}

      <style>{`
        /* Modern Search Container Styling */
        .search-container-modern {
          background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
          padding: 40px;
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          margin-bottom: 30px;
          border-top: 4px solid #667eea;
        }

        .search-title {
          color: #1a2740;
          font-size: 28px;
          font-weight: 700;
          margin-bottom: 8px;
          letter-spacing: 0.5px;
        }

        .search-subtitle {
          color: #666;
          font-size: 14px;
          margin-bottom: 30px;
          font-weight: 500;
        }

        .search-form-wrapper {
          background: white;
          padding: 25px;
          border-radius: 12px;
          border: 2px solid #e8eef5;
          box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
        }

        .search-row {
          align-items: flex-end;
        }

        .form-group-modern {
          display: flex;
          flex-direction: column;
        }

        .form-label-modern {
          font-weight: 600;
          color: #333;
          font-size: 13px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 8px;
          display: block;
        }

        .form-control-modern,
        .form-select-modern {
          border: 2px solid #e0e0e0;
          border-radius: 8px;
          padding: 12px 14px;
          font-size: 14px;
          transition: all 0.3s ease;
          background: white;
        }

        .form-control-modern:focus,
        .form-select-modern:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          outline: none;
        }

        .form-control-modern::placeholder {
          color: #bbb;
        }

        .btn-search-modern {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border: none;
          padding: 12px 30px;
          font-weight: 600;
          border-radius: 8px;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
          font-size: 14px;
          cursor: pointer;
        }

        .btn-search-modern:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 25px rgba(102, 126, 234, 0.4);
          background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
          color: white;
        }

        .btn-search-modern:active {
          transform: translateY(0);
        }

        /* Alert Styling */
        .alert-modern {
          padding: 16px 20px;
          border-radius: 10px;
          margin-bottom: 30px;
          font-weight: 500;
          border-left: 4px solid;
          animation: slideDown 0.3s ease;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .alert-success {
          background-color: #d4edda;
          color: #155724;
          border-color: #28a745;
        }

        .alert-error {
          background-color: #f8d7da;
          color: #721c24;
          border-color: #f5c6cb;
        }

        /* Support Card Styling */
        .support-card-modern {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding: 25px;
          border-radius: 12px;
          color: white;
          margin-bottom: 30px;
          display: flex;
          align-items: center;
          gap: 20px;
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
        }

        .support-icon {
          font-size: 36px;
          line-height: 1;
          min-width: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .support-content h5 {
          margin: 0 0 8px 0;
          font-weight: 700;
          font-size: 16px;
        }

        .support-content p {
          margin: 5px 0;
          font-size: 14px;
          opacity: 0.95;
        }

        .support-email {
          font-weight: 600;
        }

        .support-email a {
          color: white;
          text-decoration: none;
          border-bottom: 1px solid white;
          transition: all 0.3s ease;
        }

        .support-email a:hover {
          opacity: 0.8;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .search-container-modern {
            padding: 25px;
          }

          .search-title {
            font-size: 22px;
          }

          .search-form-wrapper {
            padding: 15px;
          }

          .form-control-modern,
          .form-select-modern {
            padding: 10px 12px;
            font-size: 13px;
          }

          .btn-search-modern {
            padding: 10px 20px;
            font-size: 13px;
            width: 100% !important;
          }

          .support-card-modern {
            flex-direction: column;
            text-align: center;
            padding: 20px;
          }

          .support-icon {
            font-size: 28px;
          }

          .support-content h5 {
            font-size: 14px;
          }

          .support-content p {
            font-size: 12px;
          }
        }

        @media (max-width: 576px) {
          .search-container-modern {
            padding: 15px;
            border-radius: 12px;
          }

          .search-title {
            font-size: 18px;
            margin-bottom: 5px;
          }

          .search-subtitle {
            font-size: 12px;
            margin-bottom: 20px;
          }

          .search-form-wrapper {
            padding: 12px;
            border-radius: 10px;
          }

          .form-label-modern {
            font-size: 12px;
            margin-bottom: 6px;
          }

          .form-control-modern,
          .form-select-modern {
            padding: 9px 10px;
            font-size: 12px;
            border-radius: 6px;
          }

          .btn-search-modern {
            padding: 8px 16px;
            font-size: 12px;
          }

          .support-card-modern {
            padding: 15px;
            gap: 12px;
          }

          .support-icon {
            font-size: 24px;
            min-width: 40px;
          }

          .support-content h5 {
            font-size: 13px;
            margin-bottom: 5px;
          }

          .support-content p {
            font-size: 11px;
            margin: 3px 0;
          }
        }
      `}</style>
  </div>
  );         
}

export default CBSEPrintView;
